import React from "react";
import { fileUrl } from "../Tools/APIs/useMyAPI";

const Video = ({ data }) => {

  const video = data?.data?.data.home_admin?.video;
  const image = data?.data?.data.hero?.image;

  return (
    <div className="w-[90%] mx-auto md:p-10">
      {video ? (
        <video
          muted
          controls
          className="mx-auto shadow-xl shadow-black/20 rounded-[15px]"
        >
          <source src={fileUrl + video} />
        </video>
      ) : image ? (
        <img
          src={fileUrl + image}
          alt="صورة تعريفية"
          className="mx-auto shadow-xl shadow-black/20 rounded-[15px]"
        />
      ) : (
        <p className="text-center text-gray-500">لا يوجد فيديو أو صورة لعرضها.</p>
      )}
    </div>
  );
};

export default Video;
